// Moved here so it's also usable in the router
import { createPinia } from "pinia"
const pinia = createPinia()
export default pinia